"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RFFFieldArray = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFinalFormArrays = require("react-final-form-arrays");

/**
 * RFFFieldArray
*/
var RFFFieldArray = function RFFFieldArray(_ref) {
  var children = _ref.children,
      fieldArrayName = _ref.fieldArrayName;
  return /*#__PURE__*/_react.default.createElement(_reactFinalFormArrays.FieldArray, {
    name: fieldArrayName
  }, function (_ref2) {
    var fields = _ref2.fields;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, fields.map(function (name, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: index,
        style: {
          width: '100%'
        }
      }, Array.isArray(children) && children.map(function (child, i) {
        return /*#__PURE__*/(0, _react.cloneElement)(child, {
          fields: fields,
          key: i,
          name: child.props.name ? "".concat(name, "[").concat(child.props.name, "]") : name,
          index: index
        });
      }), !Array.isArray(children) && /*#__PURE__*/(0, _react.cloneElement)(children, {
        fields: fields,
        name: children.props.name ? "".concat(name, "[").concat(children.props.name, "]") : name
      }));
    }));
  });
};

exports.RFFFieldArray = RFFFieldArray;
var _default = RFFFieldArray;
exports.default = _default;
RFFFieldArray.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.element), _propTypes.default.element]).isRequired,
  fieldArrayName: _propTypes.default.string.isRequired
};
RFFFieldArray.defaultProps = {};